const getColumnWidth = (columnWidth) => {
  switch (columnWidth) {
    case 'threequarters':
      return 9;
    case 'twothirds':
      return 8;
    case 'seven':
      return 7;
    case 'half':
      return 6;
    case 'five':
      return 5;
    case 'third':
      return 4;
    case 'quarter':
      return 3;
    case 'full':
    default:
      return 12;
  }
};

export default getColumnWidth;
